import React, { Component } from "react";
import { Link } from "react-router-dom";
class Footer extends Component {
  render() {
    return (
      <div className="footer ">
    
        <div className="bottomFooter">
        © 2025 -- The Wealth System. All rights reserved. Powered by Rauxmac Integrated Concepts.
        </div>

        <div className="bottomFooter">
        <Link to="/terms" className="breadcrumb-home">Terms & Condition</Link>
        </div>
        
      </div>
    );
  }
}

export default Footer;
